import { useNavigate } from "react-router-dom";
import { Row, Col, Card } from "react-bootstrap";
import ListVendorAuth from "./ListVendorAuth";
import { TextButton } from "Components/Button";
import {store} from "../../../../Store";
import {USER_ROLES} from "../../../../Utils/constants";

const ManageVendorAuth = () => {

  const navigate = useNavigate();
  
  const loginState = store.getState().loginInfo;
  const isPSOPPCAdmin = loginState.role === USER_ROLES.PSOPPCADMIN.id;

  const handleBack = () => {
    navigate("/manage/organization", { state: { orgType: "Vendor" } });
  }

  return (
    <Row >
      <Col xl={11} lg={11} md={11} sm={12}>

        <Card className="p-4" >

          <Card.Body className="text-start">

            <h1 id="mainContent" className="header1 text-start mb-3 blue bold">{isPSOPPCAdmin ? "Manage Vendor Authorization" : "Organization Vendor Authorization"}</h1>
            <br />
            {/*<h2 className="text-start mb-2 form-title">Vendor Authorizations</h2>*/}
            {/*<br />*/}
            <ListVendorAuth isPSOPPCAdmin={isPSOPPCAdmin}></ListVendorAuth>
            {/*<TextButton*/}
            {/*  variant="outline"*/}
            {/*  onClick={handleBack}*/}
            {/*  content={"Back"}*/}
            {/*  className="float-end"*/}
            {/*  */}
            {/*>*/}
            {/*</TextButton>*/}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default ManageVendorAuth;